export const scoreView = {
    "submit_successful": "ທ່ານໄດ້ສົ່ງສຳເລັດແລ້ວ!",
    "congratulations": "ຂໍສະແດງຄວາມຍິນດີດ້ວຍ!",
    "sorry": "ຂໍອະໄພ",
    "completed": "ສຳເລັດ",
};

